import { ELoginActions } from './enums';
import { ILoginForm } from './models';
import { handleLogin as handleLoginService } from './services';

export const handleLogin = (data: ILoginForm) => ({
    type: ELoginActions.LOGIN,
    payload: handleLoginService(data)
});
